import { FormikErrors } from 'formik';

import { AirlineConfiguration, AirportConfiguration } from '../../backend';
import { ConfigurationsPageFormValues } from './ConfigurationPage';

export const isAirlineConfiguration = (content: AirportConfiguration['content']): content is AirlineConfiguration => {
    return (content as AirlineConfiguration)?.type === 'AirlineConfiguration';
};

export const validateConfiguration = (
    index: number,
    c: AirportConfiguration,
    errors: FormikErrors<ConfigurationsPageFormValues>,
    values: ConfigurationsPageFormValues,
) => {
    if (isAirlineConfiguration(c.content)) {
        validateAirlineConfiguration(index, c.content, errors, values);
    }
};

const validateAirlineConfiguration = (
    index: number,
    a: AirlineConfiguration,
    errors: FormikErrors<ConfigurationsPageFormValues>,
    values: ConfigurationsPageFormValues,
) => {
    //name required
    if (!a.name) {
        errors[`configurations[${index}]['name']`] = 'required';
    }

    //codeIcao unique and required
    if (
        a.codeIcao &&
        values.configurations
            .filter(c => isAirlineConfiguration(c.content))
            .find((c2, index2) => c2.content.codeIcao === a.codeIcao && index2 !== index)
    ) {
        errors[`configurations[${index}]['codeIcao']`] = 'already used';
    }
    if (!a.codeIcao) {
        errors[`configurations[${index}]['codeIcao']`] = 'required';
    }

    //codeIata unique
    if (
        a.codeIata &&
        values.configurations
            .filter(c => isAirlineConfiguration(c.content))
            .find((c2, index2) => c2.content.codeIata === a.codeIata && index2 !== index)
    ) {
        errors[`configurations[${index}]['codeIata']`] = 'already used';
    }

    //openingOffset integer and > 0
    if (!Number.isInteger(a.gateOpeningOffset)) {
        errors[`configurations[${index}]['gateOpeningOffset']`] = 'must be integer';
    }
    if (a.gateOpeningOffset < 0) {
        errors[`configurations[${index}]['gateOpeningOffset']`] = 'must be positive';
    }

    //closingOffset integer and > 0
    if (!Number.isInteger(a.gateClosingOffset)) {
        errors[`configurations[${index}]['gateClosingOffset']`] = 'must be integer';
    }
    if (a.gateClosingOffset < 0) {
        errors[`configurations[${index}]['gateClosingOffset']`] = 'must be positive';
    }
};
